<template>
  <reference-field :label="label">
    <v-text-field
      v-model="model"
      :type="type"
      :rules="rules"
      class="pt-0 mt-0 font-weight-light subtitle-2"
      hide-details
      :placeholder="placeholder"
      :autofocus="autofocus"
    />
  </reference-field>
</template>

<script>
import ReferenceField from '@/components/References/ReferenceField';

export default {
  name: 'ReferenceInputField',
  components: { ReferenceField },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
